import { Box, Button, Typography } from '@material-ui/core';
import { TickSquare } from 'iconsax-react';
import React from 'react';
import toast from 'react-hot-toast';

export const showPWAUpdateToast = () => {
	return toast.custom(
		(t) => (
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					maxWidth: '450px',
					width: '100%',
					bgcolor: 'white',
					borderRadius: '12px',
					padding: '12px 16px',
					boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
				}}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 3 }}>
					<TickSquare size={16} style={{ fontSize: '16px', marginBottom: '-5px' }} />
					<Typography style={{ fontWeight: 500, marginInline: '4px' }} variant="subtitle1">
						نسخه جدید در دسترس است
					</Typography>
				</Box>
				<button
					style={{
						all: 'unset',
						color: 'blue',
						flexGrow: 1,
					}}
					onClick={() => {
						toast.dismiss(t.id);
						window.location.reload();
					}}
				>
					اعمال
				</button>
			</Box>
		),
		{
			duration: Infinity,
			style: {
				width: '100%',
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
			},
		},
	);
};
